import React from 'react';
import clsx from 'clsx';
import { useIntl, type MessageDescriptor } from 'react-intl';
import { TypedMemo } from '../../../../common/types';
import { PROFILE_CHIP_TEXT, type ProfileChip, type ProfileChipTone } from '../profileChips';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the Profile; each part uses its own slice of it */
import styles from '../Profile.module.scss';
/* eslint-enable css-modules/no-unused-class */

const TONE_CLASS: Readonly<Record<ProfileChipTone, string | undefined>> = {
  ok: styles.chipOk,
  amber: styles.chipAmber,
  nil: styles.chipNil,
  bad: styles.chipBad,
};

interface ProfileChipBadgeProps {
  chip: ProfileChip | { tone: ProfileChipTone; text: MessageDescriptor };
  /** The values of a text with placeholders ("{ready} of {total} ready"). */
  values?: Record<string, string | number>;
  testId?: string;
}

/** The state chip of a card (design `ap-chip`). */
const ProfileChipBadgeComponent: React.FC<ProfileChipBadgeProps> = ({ chip, values, testId }) => {
  const intl = useIntl();
  const text = 'key' in chip ? PROFILE_CHIP_TEXT[chip.key] : chip.text;
  return (
    <span
      className={clsx(styles.chip, TONE_CLASS[chip.tone])}
      data-testid={testId}
      data-chip={'key' in chip ? chip.key : undefined}
    >
      {intl.formatMessage(text, values)}
    </span>
  );
};

export const ProfileChipBadge = TypedMemo(ProfileChipBadgeComponent);
